<template>
    <div class="container-login">

        <div class="info">
            <div class="rodape-info">

                <!-- <h2>SMGE - Sistema Municipal de Gestão Escolar</h2>
                <p class="copyright" style="font-size: 14px;">NTI - Núcleo de Tecnologia da Informação - PMVC</p> -->

            </div>
        </div>
        <div class="form">

            <div class="content-form reset-text-transform">

                <!-- <img style="width: 200px;" src="/public/img/logo-login.png" /> -->

                <!-- <h1 style="text-align: center; color: #fff;">Estamos em manutenção</h1>
                <h2 style="text-align: center; color: #fff; margin-top: 10px !important;">
                    Retornaremos em breve.
                </h2> -->

                <h2>Entre com suas credenciais</h2>

                <el-form @submit.native.prevent="onSubmitLogin" :model="dados" ref="dados" label-position="top" class="u-mt-30 form-login">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item prop="username" :rules="[$requiredBlur]" key="username">
                                <el-input size="medium" id="username" placeholder="Usuário" v-model="dados.username"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item prop="password" :rules="[$requiredBlur]" key="password">
                                <el-input size="medium" id="password" placeholder="Senha" type="password" v-model="dados.password"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <div class="u-text-right">
                                <el-button style="width: 123px;" size="medium" :loading="loading" class="btn-login" type="primary" native-type="submit" plain>
                                    <i class="fas fa-sign-in-alt u-mr-5"></i>
                                    Entrar
                                </el-button>
                            </div>
                        </el-col>
                    </el-row>

                </el-form>

                <div style="text-align: center; margin-top: 100px">
                    <img style="width: 250px;" src="/public/img/logo-branca.png" />
                </div>
            </div>
        </div>

    </div>
</template>
<script>

import axios from 'axios'

export default {
  data() {
      return {
          loading: false,
          dados: {
              username: '',
              password: '',
              lembre_me: false
          },
      };
  },
  mounted () {

      sessionStorage.removeItem('ed543672Instituicao');
      sessionStorage.removeItem('ed543672Token');
  },
  methods: {
    createLog(){

        try{

            let dados = {ocorrencia: 'logou no sistema' };

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/log/store`, dados, this.$store.getters.getHeaderAuth).then(response => {

                this.$router.push("admin");

            }).catch((error) => { 

                this.$message({
                    message: 'Erro! Não foi possível realizar o login.',
                    type: 'error',
                    duration: 5000
                });
                
                this.loading = false; 
            });

        }catch(e){

            this.loading = false;

            this.$message({
                message: 'Erro! Não foi possível realizar o login.',
                type: 'error',
                duration: 5000
            });

        }

    },
    onSubmitLogin() {

        this.$refs.dados.validate((valid) =>{ if(valid){

            this.loading = true;

            axios.post(`${this.$store.state.config.baseUrlApi}/oauth/token`, this.dados, this.$store.getters.getHeader).then(response => {

                this.$store.commit('setToken', response.data.access_token);
                sessionStorage.setItem('ed543672Token', response.data.access_token);
                this.createLog();

            }).catch((error) => {

                try{

                    this.loading = false;

                    if(error.response.status == '401'){

                    this.$message({
                        message: 'Erro! Usuário não autorizado.',
                        type: 'error',
                        duration: 5000
                    });

                    }else if(error.response.status == '429'){

                    this.$message({
                        message: 'Erro! Demasiadas solicitações em curto período de tempo.',
                        type: 'error',
                        duration: 5000
                    });

                    }else{

                    this.$message({
                        message: 'Erro! Não foi possível realizar o login.',
                        type: 'error',
                        duration: 5000
                    });

                    }

                }catch(e){

                    this.loading = false;

                    this.$message({
                        message: 'Erro! Não foi possível realizar o login.',
                        type: 'error',
                        duration: 5000
                    });

                }

            });
        }});
      }
  },
};
</script>
